// import React, { useState } from "react";
// import { Card, CardContent, Typography, Button, Grid, Box } from "@mui/material";
// import OTP from './OTP'; // Assuming OTP component is in the same directory
// import { VerifyQrCodeOtpLists } from "../../redux/actions/verifyQrCodeOtpAction";
// import { useSelector, useDispatch } from "react-redux";

// const TwoFactorAuth = ({ qrCode, LoginName, PID, onSubmit }) => {
//   const [otpInput, setOtpInput] = useState("");
//   const [error, setError] = useState("");
//   const dispatch = useDispatch();

//   const verifyqrcodeoptListRes = useSelector(
//     ({ verifyqrcodeoptList }) => verifyqrcodeoptList
//   );

//   const handleSubmit = async () => {
//     // Reset error before submitting
//     setError("");

//     const verifyqrcodeoptListReq = {
//       authentication: {
//         userName: LoginName,
//         partnerId: PID,
//         otp: otpInput,
//       },
//     };

//     // Dispatch the API call
//     await dispatch(VerifyQrCodeOtpLists(verifyqrcodeoptListReq));

//     // After dispatching, check if the response is successful or not
//     if (verifyqrcodeoptListRes?.data?.status === "success") {
//       onSubmit(true); // Trigger the parent success handler
//     } else {
//       setError("Invalid OTP, please try again.");
//     }
//   };

//   return (
//     <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
//       <Card elevation={3} style={{ width: 400 }}>
//         <CardContent>
//           <div className="abc">
//             <Typography variant="h5" component="h2" gutterBottom style={{ alignItems: "center" }}>
//               2FA VERIFICATION
//             </Typography>
//           </div>
//           {qrCode && (
//             <Grid container justifyContent="center" style={{ marginBottom: 20 }}>
//               <img src={"data:image/jpeg;base64," + qrCode} alt="QR Code" style={{ width: 150, height: 150 }} />
//             </Grid>
//           )}

//           <Typography variant="body2" color="textSecondary" gutterBottom>
//             Enter the code generated by your authenticator app.
//           </Typography>

//           <OTP
//             separator={<span>-</span>}
//             value={otpInput}
//             onChange={setOtpInput}
//             length={6} // For 6-digit OTP
//           />
//           {error && (
//             <Typography variant="body2" color="error" style={{ marginTop: 10 }}>
//               {error}
//             </Typography>
//           )}

//           <Button
//             variant="contained"
//             color="primary"
//             fullWidth
//             onClick={handleSubmit}
//             style={{ marginTop: 20 }}
//           >
//             Validate
//           </Button>
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };

// export default TwoFactorAuth;
import React, { useState, useEffect } from "react";
import { Card, CardContent, Typography, Button, Grid, Box } from "@mui/material";
import OTP from './OTP'; // Assuming OTP component is in the same directory
import { VerifyQrCodeOtpLists } from "../../redux/actions/verifyQrCodeOtpAction";
import { useSelector, useDispatch } from "react-redux";

const TwoFactorAuth = ({ qrCode, LoginName, PID, onSubmit }) => {
  const [otpInput, setOtpInput] = useState("");
  const [error, setError] = useState("");
  const dispatch = useDispatch();

  const verifyqrcodeoptListRes = useSelector(
    ({ verifyqrcodeoptList }) => verifyqrcodeoptList
  );

  const handleSubmit = async () => {
    // Reset error before submitting
    setError("");

    const verifyqrcodeoptListReq = {
      authentication: {
        userName: LoginName,
        partnerId: PID,
        otp: otpInput,
      },
      
    };

    // Dispatch the API call
    dispatch(VerifyQrCodeOtpLists(verifyqrcodeoptListReq));
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        handleSubmit(); // Trigger the form submission
      }
    };

    // Attach the event listener
    window.addEventListener("keydown", handleKeyDown);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [otpInput]); // Add any dependencies like otpInput if needed

  // UseEffect to handle response changes
  useEffect(() => {
    if (verifyqrcodeoptListRes?.data?.status === "Success") {
      onSubmit(true); // Trigger the parent success handler
    } else if (verifyqrcodeoptListRes?.data?.status === "Failed" || error) {
      setError("Invalid code, please try again.");
    } 
  }, [verifyqrcodeoptListRes, onSubmit]); // Dependencies ensure the effect runs when the response changes

  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
      <Card elevation={3} style={{ width: 400 }}>
        <CardContent>
          <div className="abc">
            <Typography variant="h5" component="h2" gutterBottom style={{ alignItems: "center" }}>
              2FA VERIFICATION
            </Typography>
          </div>
          {qrCode && (
            <Grid container justifyContent="center" style={{ marginBottom: 20 }}>
              <img src={"data:image/jpeg;base64," + qrCode} alt="QR Code" style={{ width: 150, height: 150 }} />
            </Grid>
          )}

          <Typography variant="body2" color="textSecondary" gutterBottom>
            Enter the code generated by your authenticator app.
          </Typography>

          <OTP
            separator={<span>-</span>}
            value={otpInput}
            onChange={setOtpInput}
            length={6} // For 6-digit OTP
          />
          {error && (
            <Typography variant="body2" color="error" style={{ marginTop: 10 }}>
              {error}
            </Typography>
          )}

          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleSubmit}
            style={{ marginTop: 20 }}
          >
            Validate
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default TwoFactorAuth;
